import {
  Box,
  Center,
  Stack,
  Text,
  Link,
} from "@chakra-ui/layout";

import {
  Switch,
  useColorModeValue as mode,
  Tooltip,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  FormControl,
  Input,
  ModalCloseButton,
  FormLabel,
  ModalFooter,
  Img,
  MenuList,
  MenuItem,
  Menu,
  MenuButton,
  Button,
  HStack,
  Checkbox,
  Select,
  CircularProgress,
} from "@chakra-ui/react";
import theme from "@chakra-ui/theme";
import React, { useEffect, memo } from "react";
import { useSession } from "next-auth/react";
import { firebaseClient } from "../../firebaseClient";
import { getAccount, updateUser } from "../../utils/sessionHelper";
import { useRouter } from "next/dist/client/router";
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { getCampaigns, sendLeads } from "controllers/lemlist";
import toast from "react-hot-toast";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { ModalInfoIcon } from "./ModalInfoIcon";
import { textStyle, variant } from "theme/names";
import * as analytics from "../../utils/analytics";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { Select as ReactSelect } from "chakra-react-select"

export const PushLemlistPopup = ({
  isOpen,
  onClose,
  leads,
  listSelected = {} as any,
  taplioListName = "",
  disableAutoPush = false,
  refetchAll = false,
}) => {

  const initialRef = React.useRef<HTMLInputElement>(null);

  const { data: session, status } = useSession() ?? {}
  const loading = status === "loading"
  const [isLoading, setIsLoading] = React.useState(false);
  const [isSending, setIsSending] = React.useState(false);
  const [isAddDynamically, setIsAddDynamically] = React.useState(false);
  const [isDeduplicated, setIsDeduplicated] = React.useState(true);
  const [campaigns, setCampaigns] = React.useState<any[]>([]);
  const [campaigSelected, setCampaigSelected] = React.useState<any>({});
  const router = useRouter();
  const isAuthenticated = useFirebaseUser();

  const populateCampaigns = async () => {
    if (isOpen && getAccount(session)?.keyLemlist) {
      setIsLoading(true);
      let newCamps: any = await getCampaigns(session);
      // console.log('newCamps:', newCamps)
      setCampaigns(newCamps);
      setIsLoading(false);
    }
  };

  const pushLeads = async () => {

    

    if (!campaigSelected._id) {
      toast.error('Select a campaign first');
    }

    if (refetchAll) {
      let res = await fetch("https://us-central1-ez4cast.cloudfunctions.net/linkedinContacts-get?from=list&people=" + leads.map(p => p.username).join(","));
      let data = await res.json();
      if (data?.contacts) {
        leads = data.contacts;
      }
    }

    setIsSending(true);

    if (!disableAutoPush && isAddDynamically && listSelected?.id) {
      // console.log("listSelected", listSelected);
      let listOnUser = getAccount(session)?.contactLists?.find((list: any) => list.id === listSelected.id);
      if (listOnUser) {
        listOnUser.isAddAutoLemlist = true;
        listOnUser.idLemlistCampaign = campaigSelected._id;
        listOnUser.nameLemlistCampaign = campaigSelected.name;
        await updateUser(session, { contactLists: getAccount(session)?.contactLists });
      }
    }

    await sendLeads(session, campaigSelected._id, leads, isDeduplicated);

    

    setIsSending(false);
    setIsAddDynamically(false);
    onClose();
  }

  useEffect(() => {
    populateCampaigns();
  }, [isOpen, session, isAuthenticated]);


  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={true}
      initialFocusRef={initialRef}
      size="xl"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {/* <ModalInfoIcon /> */}
          Push leads from '{taplioListName}' to lemlist
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <HStack>
            <Text textStyle={textStyle["body.medium.light"]}>
              Select a lemlist campaign to send{" "}
              <b>
                {leads.length} lead{leads.length > 1 ? "s" : ""}
              </b>{" "}
              to
            </Text>
            {
              isLoading ? (
                <Box>
                  <CircularProgress ml={5} size='20px' isIndeterminate />
                </Box>
              ) : (
                <Box width="200px">
                  <ReactSelect
                    placeholder="Select option"
                    useBasicStyles
                    chakraStyles={{
                      menuList: (base) => ({
                        ...base,
                        width: "max-content",
                        maxH: "50vh"
                      })
                    }}
                    isDisabled={isLoading}
                    options={campaigns.map((c: any) => ({
                      label: c.name,
                      value: c
                    }))}
                    value={campaigSelected?.name ? {
                      label: campaigSelected.name,
                      value: campaigSelected
                    } : null}
                    onChange={option => {
                      if (option) {
                        setCampaigSelected(option.value)
                      }
                    }}
                  />
                </Box>
              )
            }
            {/* <Menu>
                <MenuButton
                  as={Button}
                  variant="outline"
                  rightIcon={<ChevronDownIcon />}
                  mt="2"
                  isLoading={isLoading}
                >
                  {campaigSelected?.name ?? "Select a campaign"}
                </MenuButton>
                <MenuList maxH="215px" overflow="scroll">
                  {
                    campaigns.map((campaign: any) => (
                      <MenuItem
                        key={campaign?._id}
                        onClick={() => {
                          setCampaigSelected(campaign);
                        }}
                      >
                        {campaign?.name}
                      </MenuItem>
                    ))
                  }
                </MenuList>
              </Menu> */}
          </HStack>
          {
            !disableAutoPush && (
              <Box
                mt={4}
                p={4}
                rounded="lg"
                border={"solid 1px " + theme.colors.gray[100]}
              >
                <Text textStyle={textStyle["body.medium.light"]} fontWeight={600}>
                  Dynamic Contact Push{" "}
                  <Text textStyle={textStyle["body.medium.light"]} as="span" fontSize="sm">
                    (pro only)
                  </Text>
                </Text>
                <Checkbox
                  mt={2}
                  fontWeight="medium"
                  size="md"
                  isChecked={isAddDynamically}
                  isDisabled={
                    getAccount(session)?.subscription?.plan !== "enterprise"
                  }
                  onChange={(e) => {
                    setIsAddDynamically(e.target.checked);
                  }}
                >
                  automatically push newly added contact to{" "}
                  {campaigSelected?.name
                    ? "'" + campaigSelected?.name + "'"
                    : "lemlist"}
                </Checkbox>
              </Box>
            )
          }
          {/* <Text textStyle={textStyle["body.medium.light"]} mt={4} fontSize="sm">Notes: only contacts with email addresses can be sent to lemlist</Text> */}
          <Checkbox
            mt={5}
            fontWeight="medium"
            size="md"
            isChecked={isDeduplicated}
            onChange={(e) => {
              setIsDeduplicated(e.target.checked);
            }}
          >
            don't push contacts if they are already on any lemlist campaign
          </Checkbox>
          <Text textStyle={textStyle["body.medium.light"]} mt={4} fontSize="sm">
            Notes: all contacts will be sent to lemlist. Activate DropContact
            enrichment on lemlist to try to find all emails.
          </Text>
        </ModalBody>

        <ModalFooter mb={2}>
          {/* <Button onClick={skipPopup} mr={3}>Skip</Button> */}
          <Button
            isDisabled={!campaigSelected._id}
            onClick={async () => {
              pushLeads();
            }}
            //   colorScheme="blue"
            //   bg="blue.700"
            //   _hover={{ bg: "blue.600" }}
            //   color="white"
            isLoading={isSending}
            variant={variant.Button.primary}
          >
            Send leads to lemlist
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
